import React, { useState, useEffect } from 'react';
import api from '../services/api';
import '../styles/buscador.css';

function BuscadorPacientes() {
  const [pacientes, setPacientes] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [pagina, setPagina] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalRegistros, setTotalRegistros] = useState(0);

  const ITEMS_POR_PAGINA = 10;

  useEffect(() => {
    cargarPacientes();
  }, [pagina, busqueda]);

  const cargarPacientes = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: pagina,
        limit: ITEMS_POR_PAGINA,
        ...(busqueda && { buscar: busqueda })
      });

      const response = await api.get(`/pacientes?${params}`);
      const { data, pagination } = response.data;

      setPacientes(data);
      setTotalPaginas(pagination.pages);
      setTotalRegistros(pagination.total);
    } catch (error) {
      console.error('Error al cargar pacientes:', error);
      alert('Error al cargar pacientes');
    } finally {
      setLoading(false);
    }
  };

  const manejarBusqueda = (e) => {
    const valor = e.target.value;
    setBusqueda(valor);
    setPagina(1); // Reiniciar a página 1
  };

  const irAPagina = (nuevaPagina) => {
    if (nuevaPagina > 0 && nuevaPagina <= totalPaginas) {
      setPagina(nuevaPagina);
    }
  };

  return (
    <div className="buscador-container">
      <div className="buscador-header">
        <h2>Gestión de Pacientes</h2>
        <input
          type="text"
          placeholder="🔍 Buscar por nombre, email o teléfono..."
          value={busqueda}
          onChange={manejarBusqueda}
          className="buscador-input"
        />
      </div>

      {loading && <p className="loading">Cargando...</p>}

      <div className="pacientes-tabla">
        <table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Email</th>
              <th>Teléfono</th>
              <th>Fecha Nacimiento</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {pacientes.length > 0 ? (
              pacientes.map((paciente) => (
                <tr key={paciente.id}>
                  <td>{paciente.nombre}</td>
                  <td>{paciente.email || '-'}</td>
                  <td>{paciente.telefono || '-'}</td>
                  <td>{paciente.fecha_nacimiento || '-'}</td>
                  <td>
                    <button className="btn-editar">Editar</button>
                    <button className="btn-ver">Ver</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="sin-resultados">
                  No hay pacientes registrados
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Info y Paginación */}
      <div className="paginacion-container">
        <p className="info-registros">
          Mostrando {(pagina - 1) * ITEMS_POR_PAGINA + 1} a{' '}
          {Math.min(pagina * ITEMS_POR_PAGINA, totalRegistros)} de {totalRegistros}{' '}
          registros
        </p>

        <div className="controles-paginacion">
          <button
            className="btn-pagina"
            onClick={() => irAPagina(pagina - 1)}
            disabled={pagina === 1}
          >
            ← Anterior
          </button>

          <span className="numero-pagina">
            Página {pagina} de {totalPaginas}
          </span>

          <button
            className="btn-pagina"
            onClick={() => irAPagina(pagina + 1)}
            disabled={pagina === totalPaginas}
          >
            Siguiente →
          </button>
        </div>
      </div>
    </div>
  );
}

export default BuscadorPacientes;
